import styled from 'styled-components';
import { DEFAULT_COLORS } from 'components/core/colors';

export const ConfirmModalBody = styled.div`
  text-align: center;
`;

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  width: 100%;
`;

export const ConfirmModalIcon = styled.div`
  color: ${DEFAULT_COLORS.accent.primaryAlt};
  line-height: 0;
`;

export const ConfirmModalTitle = styled.h2`
  margin: 20px 0 12px;
  font-size: 1.4rem;
  font-weight: 500;
`;

export const ConfirmModalDescription = styled.p`
  color: ${DEFAULT_COLORS.grey60};
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0;
`;
